/**
 * @file src/helpers/utils/isEmbedded.ts
 * @exports isEmbedded
 * @summary Detects if the current window is embedded within an iframe or frame.
 */

export function isEmbedded() {
	try {
		return window.self !== window.top;
	} catch (e) {
		// cross-origin access blew up ⇒ definitely framed
		return true;
	}
}
